import React from "react";
import styled from "styled-components";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Image from "material-ui-image";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ScheduleIcon from "@material-ui/icons/Schedule";
import RoomIcon from "@material-ui/icons/Room";
import BusinessIcon from "@material-ui/icons/Business";
import Typography from "@material-ui/core/Typography";
import DetailListItem from "../../ListItems/DetailListItem";
import CalendarEvent from "../../../Models/CalendarEvent";
import sanitizeDateAndTime from "../../../Helper/sanitizeDateAndTime";
import markup from "../../../Helper/markup";

interface EventPageBodyProps {
    calendarEvent: CalendarEvent;
}

interface EventPageBodyImageViewProps {
    image: string;
}
interface EventPageBodyDetailSectionProps {
    calendarEvent: CalendarEvent;
}

interface EventPageBodyDescriptionSectionProps {
    description: string;
}

const BodyContainer = styled(DialogContent)`
  padding-top: 8px;
`;
const ContentContainer = styled(Paper)`
  margin-top: 8px;
  margin-bottom: 8px;
`;
const DescriptionContentContainer = styled(Paper)`
  margin-top: 8px;
  padding-left: 16px;
  padding-right: 16px;
  overflow: hidden;
`;

const DescriptionContentText = styled(Typography)`
  word-wrap: break-word;
`;

const EventPageBodyImageView = (props: EventPageBodyImageViewProps) => {
    const {image} = props;
    return (
        < Grid item xs={12}>
            <Image
                animationDuration={1000}
                src={image}
                disableSpinner={true}
                imageStyle={{width: '100%', borderRadius: 4, height: 'auto', position: 'relative'}}
                style={{
                    width: '100%' ,
                    paddingTop: 0
                }}
            />
        </Grid>
    );
}

const EventPageBodyDetailSection = (props: EventPageBodyDetailSectionProps) => {
    const {calendarEvent} = props;
    let dateTime;
    if (calendarEvent)
         dateTime = sanitizeDateAndTime(calendarEvent);

    return (
        <Grid item xs={12}>
            <List>
                <DetailListItem
                    title={dateTime?.startDate || ""}
                    icon={<DateRangeIcon />}
                    showDivider={true}
                    displayFavorite={false}
                    item={calendarEvent}
                />
                <DetailListItem
                    title={`${dateTime?.startTime} - ${dateTime?.endTime}`}
                    icon={<ScheduleIcon />}
                    showDivider={true}
                    displayFavorite={false}
                    item={calendarEvent}
                />
                {calendarEvent?.location &&
                <DetailListItem
                    title={calendarEvent?.location || ""}
                    icon={<RoomIcon/>}
                    showDivider={true}
                    displayFavorite={false}
                    item={calendarEvent}
                />
                }
                <DetailListItem
                    title={calendarEvent?.host || ""}
                    icon={<BusinessIcon />}
                    showDivider={true}
                    displayFavorite={false}
                    item={calendarEvent}
                />
            </List>
    </Grid>
    );
};

const EventPageBodyDescriptionSection = (props: EventPageBodyDescriptionSectionProps) => {
    const {description} = props;
    return (
        <Grid item xs={12}>
                <DescriptionContentText
                    dangerouslySetInnerHTML={markup(description)}
                />
        </Grid>
    );
};


const EventPageBody = (props: EventPageBodyProps) => {
    const {calendarEvent} = props;


    return (
        <BodyContainer dividers>
            <Grid container>
                {calendarEvent?.image && calendarEvent.image != '' &&
                    <EventPageBodyImageView image={calendarEvent.image} />
                }
                <EventPageBodyDetailSection calendarEvent={calendarEvent} />
                <EventPageBodyDescriptionSection description={calendarEvent?.description || ""} />
            </Grid>
        </BodyContainer>
    );
}
//
// icon: {
//     fill: '#D45D00 !important'
// }
// img: {
//     width: '100%',
//         marginTop: 8,
//         marginBottom: 8,
//         borderRadius: 4
// },
//
// media: {
//
//     height: '50vw'
// },
export default EventPageBody;